import { render, staticRenderFns } from "./PaymentMethodeInfo.vue?vue&type=template&id=4938494f&scoped=true&"
import script from "./PaymentMethodeInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938494f",
  null
  
)

export default component.exports